// src/Tuning/WhyChooseUs/WhyChooseUsEdit/WhyChooseUsEdit.jsx
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Update, GetById } from 'adminApi/WhyChooseUsApi/WhyChooseUs';
import { validateForm } from 'utils/validation';
import { WhyChooseUsAddRules } from "validation/ValidationRules";
import Spinner from 'Common/Globle/Spinner';
import EditWhyChooseUsForm from './Componates/EditWhyChooseUsForm';
import fields from '../json/WhyChooseUsFields.json';
import useFormChange from 'Hooks/useFormChange';
import useFormSubmit from 'Hooks/useFormSubmit';
import useFetchFormDataById from 'Hooks/useFetchFormDataById';

const WhyChooseUsEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  const initialValues = formdata.reduce((acc, f) => ({ ...acc, [f.name]: '' }), {});

  const { values, errors, handleChange, handleFileChange, setErrors, setValues } = useFormChange(
    initialValues,
    WhyChooseUsAddRules
  );

  // Load existing entry
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const fd = new FormData();
      Object.entries(formValues).forEach(([k, v]) => fd.append(k, v ?? ''));
      return await Update({ id, data: fd });
    },
    (vals) => {
      // If icon is unchanged (string URL) remove it before validation
      if (typeof vals.icon === 'string') delete vals.icon;
      const err = validateForm(vals, WhyChooseUsAddRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    'Update entry successfully'
  );

  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditWhyChooseUsForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.iconPreview || values.icon}
        title="Update Why Choose Us"
        handleFileChange={handleFileChange}
      />
    </>
  );
};

export default WhyChooseUsEdit;
